/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SearchEvidences200ResponseInnerErrors } from './search-evidences200-response-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { SearchEvidences200ResponseInnerInvoiceIssuer } from './search-evidences200-response-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { SearchEvidences200ResponseInnerUpdatedBy } from './search-evidences200-response-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { SearchEvidences200ResponseInnerUploadedBy } from './search-evidences200-response-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { SearchEvidences200ResponseInnerWarnings } from './search-evidences200-response-inner-warnings';

/**
 * 
 * @export
 * @interface SearchEvidences200ResponseInner
 */
export interface SearchEvidences200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'paymentType': SearchEvidences200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'paidAt': string;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'issuer': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'electronicMethod': SearchEvidences200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'documentSize': SearchEvidences200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'legalValidity': SearchEvidences200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchEvidences200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerInvoiceIssuer}
     * @memberof SearchEvidences200ResponseInner
     */
    'invoiceIssuer': SearchEvidences200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'dpiError': SearchEvidences200ResponseInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'detectedDpiError': SearchEvidences200ResponseInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'calculatedDpiError': SearchEvidences200ResponseInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'colorGradationError': SearchEvidences200ResponseInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'heightMillisError': SearchEvidences200ResponseInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'widthMillisError': SearchEvidences200ResponseInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerErrors}
     * @memberof SearchEvidences200ResponseInner
     */
    'errors': SearchEvidences200ResponseInnerErrors;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerWarnings}
     * @memberof SearchEvidences200ResponseInner
     */
    'warnings': SearchEvidences200ResponseInnerWarnings;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerUpdatedBy}
     * @memberof SearchEvidences200ResponseInner
     */
    'updatedBy': SearchEvidences200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerUploadedBy}
     * @memberof SearchEvidences200ResponseInner
     */
    'uploadedBy': SearchEvidences200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchEvidences200ResponseInner
     */
    'deleted': boolean;
}

export const SearchEvidences200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type SearchEvidences200ResponseInnerPaymentTypeEnum = typeof SearchEvidences200ResponseInnerPaymentTypeEnum[keyof typeof SearchEvidences200ResponseInnerPaymentTypeEnum];
export const SearchEvidences200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerElectronicMethodEnum = typeof SearchEvidences200ResponseInnerElectronicMethodEnum[keyof typeof SearchEvidences200ResponseInnerElectronicMethodEnum];
export const SearchEvidences200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerDocumentSizeEnum = typeof SearchEvidences200ResponseInnerDocumentSizeEnum[keyof typeof SearchEvidences200ResponseInnerDocumentSizeEnum];
export const SearchEvidences200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type SearchEvidences200ResponseInnerLegalValidityEnum = typeof SearchEvidences200ResponseInnerLegalValidityEnum[keyof typeof SearchEvidences200ResponseInnerLegalValidityEnum];
export const SearchEvidences200ResponseInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerDpiErrorEnum = typeof SearchEvidences200ResponseInnerDpiErrorEnum[keyof typeof SearchEvidences200ResponseInnerDpiErrorEnum];
export const SearchEvidences200ResponseInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerDetectedDpiErrorEnum = typeof SearchEvidences200ResponseInnerDetectedDpiErrorEnum[keyof typeof SearchEvidences200ResponseInnerDetectedDpiErrorEnum];
export const SearchEvidences200ResponseInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerCalculatedDpiErrorEnum = typeof SearchEvidences200ResponseInnerCalculatedDpiErrorEnum[keyof typeof SearchEvidences200ResponseInnerCalculatedDpiErrorEnum];
export const SearchEvidences200ResponseInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SearchEvidences200ResponseInnerColorGradationErrorEnum = typeof SearchEvidences200ResponseInnerColorGradationErrorEnum[keyof typeof SearchEvidences200ResponseInnerColorGradationErrorEnum];
export const SearchEvidences200ResponseInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerHeightMillisErrorEnum = typeof SearchEvidences200ResponseInnerHeightMillisErrorEnum[keyof typeof SearchEvidences200ResponseInnerHeightMillisErrorEnum];
export const SearchEvidences200ResponseInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerWidthMillisErrorEnum = typeof SearchEvidences200ResponseInnerWidthMillisErrorEnum[keyof typeof SearchEvidences200ResponseInnerWidthMillisErrorEnum];


